/* eslint class-methods-use-this: ["error", { "exceptMethods": ["getContent"] }] */
import { EventEmitter } from 'events';
import { tmpl } from '@/utils/util-extent';

const { $, google } = window;

export default class LocationMap extends EventEmitter {
  constructor(dom, list, opt) {
    super();
    this.list = list;
    this.listDict = {};
    this.markerDict = {};
    this.infoWindow = new google.maps.InfoWindow();
    this.defOpt = {
      center: { lat: 23.69781, lng: 120.96051499999999 },
      zoom: 7,
    };
    this.opt = $.extend({
      center: this.defOpt.center,
      zoom: this.defOpt.zoom,
      mapTypeControl: false,
      zoomControl: false,
      streetViewControl: false,
    }, opt);

    this.map = new google.maps.Map(dom, this.opt);
    this.addMarkers();
  }

  addMarkers() {
    const self = this;
    const icon = LocationMap.getIcon();
    let item; let marker;

    this.markerDict = {};
    this.listDict = {};

    for (let index = 0; index < this.list.length; index += 1) {
      item = this.list[index];
      marker = new google.maps.Marker({
        position: {
          lat: item.lat,
          lng: item.lng,
        },
        map: this.map,
        icon,
        visible: false,
      });
      marker.addListener('click', (function click(key) {
        return () => {
          self.onMarkerClick(key);
        };
      }(item.key)));

      this.listDict[item.key] = item;
      this.markerDict[item.key] = marker;
    }
  }

  updateNewMarkers(list) {
    this.infoWindow.close();
    let marker;
    Object.keys(this.markerDict).forEach((key) => {
      marker = this.markerDict[key];
      marker.setVisible(false);
    });
    this.list = list;
    this.addMarkers();
  }

  onMarkerClick(key) {
    this.showInfoWindow(key);
    this.emit(LocationMap.MARKER_CLICK, key);
  }

  // 地圖顯示marker內容
  getContent(data) {
    const $item = $(tmpl($('#template-map-info').html(), data));
    if (data.chargerCount === '' || !data.chargerCount) $item.find('.charger-count').remove();
    if (data.pricing === '' || !data.pricing) $item.find('.pricing').remove();
    if (data.payment === '' || !data.payment) $item.find('.payment').remove();
    if (data.tel === '' || !data.tel) $item.find('.tel').remove();
    if (!data.aed) $item.find('.aed').remove();
    if (!data.exclusive) $item.find('.exclusive').remove();
    return $item[0];
  }

  showInfoWindow(key) {
    const data = this.listDict[key];
    const content = this.getContent(data);
    $(content).find('.direction-btn').attr('href', this.getDirectionLink(data.lat, data.lng));
    this.infoWindow.setContent($(content)[0]);
    this.infoWindow.open(this.map, this.markerDict[key]);
  }

  updateVisibleMarkers(list) {
    this.infoWindow.close();
    const bounds = new google.maps.LatLngBounds();

    let item; const listDict = {};
    for (let index = 0; index < list.length; index += 1) {
      item = list[index];
      listDict[item.key] = item;
    }

    let marker; let isMatch = false;
    let markerVisibleCount = 0;
    let lastMatchKey;
    Object.keys(this.markerDict).forEach((key) => {
      marker = this.markerDict[key];
      if (listDict[key]) {
        isMatch = true;
        markerVisibleCount += 1;
        lastMatchKey = key;
        marker.setVisible(true);
        bounds.extend(marker.getPosition());
      } else {
        marker.setVisible(false);
      }
    });

    if (isMatch) {
      if (markerVisibleCount > 1) {
        this.map.fitBounds(bounds);
      } else {
        this.panByMarkerKey(lastMatchKey);
      }
    } else {
      this.map.setOptions(this.defOpt);
    }
  }

  panByMarkerKey(key) {
    // console.log(this._map.getZoom());
    const item = this.listDict[key];
    this.map.panTo({
      lat: item.lat,
      lng: item.lng,
    });
    const maxZoom = 16;
    // if (this._map.getZoom() < maxZoom)
    this.map.setZoom(maxZoom);
    this.showInfoWindow(key);
  }

  static getIcon() {
    return {
      url: LocationMap.ICON_URL,
      scaledSize: new google.maps.Size(61, 48),
    };
  }

  static getLink(lat, lng) {
    const linkQ = '{LAT},{LNG}/'.replace(/{LNG}/g, lng).replace(/{LAT}/g, lat);
    const link = `https://www.google.com.tw/maps/place/${linkQ}`;
    return link;
  }

  static getLinkByAddr(addr) {
    const link = `https://www.google.com.tw/maps/place/${addr}`;
    return link;
  }

  static getDistance(lat1, lon1, lat2, lon2) {
    const deg2rad = Math.PI / 180;
    const R = 6371; // Radius of the earth in km
    const dLat = deg2rad * (lat2 - lat1); // deg2rad below
    const dLon = deg2rad * (lon2 - lon1);
    const a = Math.sin(dLat / 2) * Math.sin(dLat / 2)
            + Math.cos(deg2rad * lat1) * Math.cos(deg2rad * lat2)
            * Math.sin(dLon / 2) * Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const d = R * c; // Distance in km
    return d;
  }

  getDirectionLink(tolat, tolng) {
    if (this.currentPosition != null) {
      return `https://www.google.com/maps/dir/${this.currentPosition.lat},${this.currentPosition.lng}/${tolat},${tolng}`;
    }
    return '';
  }
}

LocationMap.MARKER_CLICK = 'LocationMap.MarkerClick';
LocationMap.ICON_URL = '/images/icons/location-pin.png';
